import { Component, Input } from '@angular/core'
import { MbConstants } from '../../../shared/mb-constants'

@Component({
  selector: 'mb-myaccount-no-data-card',
  templateUrl: './mb-myaccount-no-data-card.component.html',
  styleUrls: ['./mb-myaccount-no-data-card.component.scss']
})
export class MbMyaccountNoDataCardComponent {
  @Input() message: String = ''
  @Input() link: String = ''
  @Input() linkText: String = ''

  readonly allProductCategoriesUrl = MbConstants.ALL_PRODUCT_CATEGORIES_URL
}
